import React, { useCallback, useEffect, useState } from 'react';
import { Link,useNavigate } from 'react-router-dom';

import { Form, Input, Button, message } from 'antd';
import { AuthWrapper } from './style';
import Heading from '../../components/ui/heading/heading';
import { useDispatch, useSelector } from 'react-redux';
import { sendOtpForgot, verifyOtpForgot, changePassword, forgotInitialState } from '../../redux/authentication/actionCreator';
import Alert from '../../components/ui/alerts/alerts';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import AuthLayout from './Index';

function ForgotPassword() {
    
    const history = useNavigate();
    const dispatch = useDispatch();

    const isLoading = useSelector((state) => state.forgot.loading);
    const authError = useSelector((state) => state.forgot.error);
    const forgotData = useSelector((state) => state.forgot);

    
    const [form] = Form.useForm();

    const handleForgotSubmit = useCallback((value) => {
        
        dispatch(sendOtpForgot(value));
    }, [dispatch]);

    const validateOTP = (_, value) => {
        if (!/^\d{6}$/.test(value)) {
          return Promise.reject(new Error('OTP must be a 6-digit number!'));
        }
        return Promise.resolve();
    };
    
    const handleOTPSubmit = useCallback((value) => {
        const modifiedValues = { ...value,username:forgotData.username};
        dispatch(verifyOtpForgot(modifiedValues));
    }, [dispatch, forgotData]);

    const [countdown, setCountdown] = useState(60); // Initial countdown time
    const [otpSent, setOTPSent] = useState('');
  
    // Function to handle OTP resend
    const handleResendOTP = () => {
        // Logic to resend OTP
        setOTPSent(true); // Set OTP sent flag to true
        // Start countdown timer
        dispatch(sendOtpForgot({username:forgotData.username}));

        let timeLeft = 60;
        const interval = setInterval(() => {
            timeLeft--;
            setCountdown(timeLeft);
            if (timeLeft === 0) {
            clearInterval(interval);
            setOTPSent(false); // Reset OTP sent flag
            }
        }, 1000);
    };

    const validatePassword = (_, value) => {
        if (value && value.length < 8) {
            return Promise.reject(new Error('Password must be at least 8 characters'));
        }
        return Promise.resolve();
    };
    
      
    const validateConfirmPassword = (_, value) => {
        if (value && value !== form.getFieldValue('password')) {
            return Promise.reject(new Error('The two passwords do not match'));
        }
        return Promise.resolve();
    };

    const handleChangeSubmit = useCallback((value) => {
        const modifiedValues = { ...value,username:forgotData.username};
        dispatch(changePassword(modifiedValues));
        // history.push('/');
        
    }, [dispatch,forgotData]);

    
    useEffect(()=> {
        if(forgotData.otp === true && forgotData.change === true && forgotData.forgot === true && forgotData.error === ''){
            message.success('Password Updated Successfully. Please login')
            history.push('/');
        }  
    },[history,forgotData])

    const  goforgotpage = () => {
        dispatch(forgotInitialState());
    }
    

    return (
        <AuthWrapper>
            <div className="auth-contents">
                <div className="auth-contents-logo">
                    <img src={require(`../../static/img/login-logo.png`)} alt="logo" width="130" />
                </div>
                {forgotData.type === 'forgot' && (
                    <div className="auth-contents-form">
                        <Form name="forgotPass" form={form} onFinish={handleForgotSubmit} layout="vertical">
                            <Heading as="h3">Forgot Password?</Heading>
                            <p className="forgot-text"> Enter the Username  you will get Instructions to Reset your Password. </p>
                            <Form.Item label="Username" name="username" rules={[{  message: 'Please Enter Your Username!', required: true}]} >
                                <Input placeholder="Username" />
                            </Form.Item>

                            { authError && (<div className="auth-form-action-error"><Alert type="error" message={authError} closable  outlined /></div>)}
                            
                            <Button className="btn-signin " htmlType="submit" type="primary" size="large" block>
                                {isLoading ? 'Loading...' : 'Submit'}
                            </Button>

                            <div className="mt-30 text-right">
                                <p className="return-text">Return to <Link to="/" className="forgot-pass-link">Sign In</Link> </p>
                            </div>
                        </Form>
                    </div>
                )}

                {forgotData.type === 'otp' && (
                    <div className="auth-contents-form">
                        <Form name="otp_form" form={form} layout="vertical" onFinish={handleOTPSubmit}>
                            <Heading as="h3"> <Link to="#" onClick={goforgotpage} ><FontAwesomeIcon icon="fa-solid fa-circle-arrow-left" /></Link> OTP </Heading>
                            <p className="forgot-text"> Enter the OTP. </p>
                            <Form.Item name="otp" rules={[{ required: true, message: 'Please input your OTP!', },{ validator: validateOTP }]} >
                                <Input placeholder="Enter OTP" maxLength={6} />
                            </Form.Item>

                            { authError && (<div className="auth-form-action-error"><Alert type="error" message={authError} closable  outlined /></div>)}

                            <Button type="primary" htmlType="submit" size="large" block>
                                {isLoading ? 'Loading...' : 'Validate OTP'}
                            </Button>
                            
                            <div className="auth-form-action-otp">
                                {!otpSent && (
                                    <Button type="info" size="large" onClick={handleResendOTP} block>Resend OTP</Button>
                                )}

                                {otpSent && (
                                    <Button type="info" size="large"  disabled block >Resend OTP ({countdown})</Button>
                                )}
                            </div>
                            <div className="mt-30 text-right">
                                <p className="return-text">Return to <Link to="/" className="forgot-pass-link">Sign In</Link> </p>
                            </div>
                        </Form>
                    </div>
                )}

                {forgotData.type === 'change' && (
                    <div className="auth-contents-form">
                        <Form name="forgotPass" form={form} onFinish={handleChangeSubmit} layout="vertical">
                            <Heading as="h3" > <Link to="#" onClick={goforgotpage} ><FontAwesomeIcon icon="fa-solid fa-circle-arrow-left" /></Link> Change Password </Heading>
                            <p className="forgot-text"> Update your Password </p>
                            <Form.Item label="New Password" name="password" rules={[{  message: 'Please Enter Your New Password!', required: true},  { validator: validatePassword } ]} >
                                <Input.Password placeholder="New Password" />
                            </Form.Item>

                            <Form.Item  name="confirm_password" label="Confirm Password" dependencies={['password']} rules={[ { required: true, message: 'Please confirm your password!' }, { validator: validateConfirmPassword }, ]} >
                                <Input.Password placeholder="Confirm Password" />
                            </Form.Item>

                            { authError && (<div className="auth-form-action-error"><Alert type="error" message={authError} closable  outlined /></div>)}
                            
                            <Button className="btn-signin " htmlType="submit" type="primary" size="large" block>
                                {isLoading ? 'Loading...' : 'Submit'}
                            </Button>
                            <div className="mt-30 text-right">
                                <p className="return-text">Return to <Link to="/" className="forgot-pass-link">Sign In</Link> </p>
                            </div>
                        </Form>
                    </div>
                )}
            </div>
        </AuthWrapper>
    );
}

export default AuthLayout(ForgotPassword);
